export default "__VITE_ASSET__DaUlYcBL__"